// The agent writes links against the canonical admin host, because that is what
// it is told to do and what makes the persisted answer correct for anyone
// reading it later. But in a QA env the page is served from a per-PR domain, so
// following one of those links leaves the environment entirely and lands on
// production - looking at a different database, with the answer's own site.
//
// So the renderer rewrites an admin link onto the origin it is running on. Only
// the host changes; path, query and hash are the agent's. Anything that is not
// an admin-app URL (a datasets link, an external reference) is left alone.
const ADMIN_HOSTS = ["admin.inrange.io"];
export const toCurrentOrigin = (href: string, origin: string): string => {
  try {
    const url = new URL(href, origin);
    if (!ADMIN_HOSTS.includes(url.host)) return href;
    return `${origin}${url.pathname}${url.search}${url.hash}`;
  } catch {
    // Not a URL we can parse - leave it exactly as written rather than
    // mangling it.
    return href;
  }
};
